<template>
  <div class="gc-list-project-wrap">
    <van-nav-bar :border="false"
                 title="审核"
                 left-arrow
                 @click-left="$router.back()"
    />
    <van-sticky>
      <div class="tab-project-wrap">
        <!-- <div class="item" @click="onTab('',0)" :class="{'active':activeIndex==0}" >全部</div> -->
        <div class="item" @click="onTab(6,1)" :class="{'active':activeIndex==1}">立项审核</div>
        <div class="item" @click="onTab(5,2)" :class="{'active':activeIndex==2}">参与审核</div>
        <div class="item" @click="onTab(3,3)" :class="{'active':activeIndex==3}">交付审核</div>
      </div>
    </van-sticky>

    <!-- :immediate-check="false" 初次进入时是否调用-->
    <ul class="list-project-menu">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad()"

        >
          <div v-if="status==6">
            <router-link tag="li" v-for="(item,index) in projectList" :to="{name:'ReviewStart',params:{sysno:item.ProItem.Sysno}}" class="item"
                         :key="index">
              <div class="title">{{ item.ProItem.Name }}
                <i class="i0"></i>
              </div>
              <div class="info">
                <p><span>项目金额：</span>¥{{ item.ProMoney }}</p>
                <p><span>项目时间：</span>{{ item.ProDate.substr(0, 10) + '至' + item.ProDate.substr(11, 10) }}</p>
                <p><span>参与人数：</span>0人</p>
                <p><span>项目进度：</span>0%</p>
              </div>
            </router-link>
          </div>
          <div v-if="status==5">
            <router-link tag="li" v-for="(item,index) in projectList" :to="{name:'ReviewJoin',params:{sysno:item.ProItem.Sysno}}" class="item"
                         :key="index">
              <div class="title">{{ item.ProItem.Name }}
                <i class="i0"></i>
              </div>
              <div class="info">
                <p><span>项目金额：</span>¥{{ item.ProMoney }}</p>
                <p><span>项目时间：</span>{{ item.ProDate.substr(0, 10) + '至' + item.ProDate.substr(11, 10) }}</p>
                <p><span>参与人数：</span>{{ item.JoinPeo }}人</p>
                <p><span>项目进度：</span>0%</p>
              </div>
            </router-link>
          </div>
          <div v-if="status==3">
            <router-link tag="li" v-for="(item,index) in projectList" :to="{name:'ReviewEnd',params:{sysno:item.ProItem.Sysno}}" class="item"
                         :key="index">
              <div class="title">{{ item.ProItem.Name }}
                <i class="i0"></i>
              </div>
              <div class="info">
                <p><span>项目金额：</span>¥{{ item.ProMoney }}</p>
                <p><span>项目时间：</span>{{ item.ProDate.substr(0, 10) + '至' + item.ProDate.substr(11, 10) }}</p>
                <p><span>参与人数：</span>{{ item.JoinPeo }}人</p>
                <p><span>项目进度：</span>100%</p>
              </div>
            </router-link>
          </div>

        </van-list>
      </van-pull-refresh>
    </ul>

  </div>
</template>

<script>
var isKeepAlive = false
var isClick = false

export default {
  data() {
    return {
      activeIndex: 1,
      status: 6,
      projectList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pcount: 10,
      allcount: 0
    }
  },
  mounted() {

  },
  beforeRouteEnter(to, from, next) {
    console.log(from);
    if (from.name == "ReviewStart" || from.name == "ReviewJoin" || from.name == "ReviewEnd") {
      to.meta.keepAlive = true;
      isKeepAlive = true
      isClick = false
    } else {
      to.meta.keepAlive = false;
      isKeepAlive = false
    }
    next();
  },
  activated() {
    console.log('activated');
    this.onRefresh();
  },
  methods: {
    onLoad() {
      if (this.status == 5) {
        // 参与审核
        this.WebGetProjectAuditInfoLst(this.status);
      } else if (this.status == 3) {
        // 交付审核
        this.WebGetCheckProjectSimpleInfoLst(this.status)
      } else {
        // 立项审核
        this.WebGetProjectSimpleInfoLst(this.status);
      }
      // this.page++;
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.page = 1;
      this.projectList = [];
      this.onLoad()
    },
    // 立项审核
    WebGetProjectSimpleInfoLst(status) {
      let data = {
        // UserId: localStorage.getItem('UserSysno'),
        UserSysno: localStorage.getItem('UserSysno'),
        StatusKey: status, //6立项审核 5参与审核 3交付审核
        // DepSysno: localStorage.getItem('GovDepSysno'),
        // page: this.page,
        // pcount: this.pcount
      }
      if (localStorage.getItem('isBoss') == 1) {
        data = {
          StatusKey: status
        }
      }
      this.$baseajax.normalJsonp(this.$base.baseProject + '/WebGetProjectSimpleInfoLst', data, res => {
        console.log(res);
        if (this.refreshing) {
          this.refreshing = false;
        }
        this.loading = false

        res = res.WebGetProjectSimpleInfoLstResult
        if (res.ResponseCode == 1) {
          this.allcount = res.AllCount;
          if (res.ItemLst) {
            this.projectList.push(...res.ItemLst)
          }
          if (this.projectList.length >= this.allcount) {
            this.finished = true
          } else {
            this.page++
          }
          // 位置保存 如果是详情返回的保存位置
          setTimeout(() => {
            console.log(window.targetPosition);
            if (window.targetPosition && isKeepAlive && !isClick) {
              window.scrollTo(window.targetPosition.x, window.targetPosition.y);
            }
          }, 0);

        } else {
          this.finished = true
        }
      }, err => {
      })
    },
    // 参与审核列表
    WebGetProjectAuditInfoLst(status) {
      let data = {
        UserSysno: localStorage.getItem('UserSysno'),
        StatusKey: status, //5参与审核
        // DepSysno: localStorage.getItem('GovDepSysno'),
        // page: this.page,
        // pcount: this.pcount
      }
      this.$baseajax.normalJsonp(this.$base.baseProject + '/WebGetProjectAuditInfoLst', data, res => {
        console.log(res);
        if (this.refreshing) {
          this.refreshing = false;
        }
        this.loading = false

        res = res.WebGetProjectAuditInfoLstResult
        if (res.ResponseCode == 1) {
          this.allcount = res.AllCount;
          if (res.ItemLst) {
            this.projectList.push(...res.ItemLst)
          }
          if (this.projectList.length >= this.allcount) {
            this.finished = true
          } else {
            this.page++
          }

          // 位置保存 如果是详情返回的保存位置
          setTimeout(() => {
            console.log(window.targetPosition);
            if (window.targetPosition && isKeepAlive && !isClick) {
              window.scrollTo(window.targetPosition.x, window.targetPosition.y);
            }
          }, 0);

        } else {
          this.finished = true
        }
      }, err => {
      })
    },
    // 交付审核
    WebGetCheckProjectSimpleInfoLst(status) {
      let data = {
        UserSysno: localStorage.getItem('UserSysno'),
        StatusKey: status, //3验收审核
        // DepSysno: localStorage.getItem('GovDepSysno'),
        // page: this.page,
        // pcount: this.pcount
      }
      this.$baseajax.normalJsonp(this.$base.baseProject + '/WebGetCheckProjectSimpleInfoLst', data, res => {
        console.log(res);
        if (this.refreshing) {
          this.refreshing = false;
        }
        this.loading = false

        res = res.WebGetCheckProjectSimpleInfoLstResult
        if (res.ResponseCode == 1) {
          this.allcount = res.AllCount;
          if (res.ItemLst) {
            this.projectList.push(...res.ItemLst)
          }
          if (this.projectList.length >= this.allcount) {
            this.finished = true
          } else {
            this.page++
          }
          // 位置保存 如果是详情返回的保存位置
          setTimeout(() => {
            console.log(window.targetPosition);
            if (window.targetPosition && isKeepAlive && !isClick) {
              window.scrollTo(window.targetPosition.x, window.targetPosition.y);
            }
          }, 0);
        } else {
          this.finished = true
        }
      }, err => {
      })
    },
    onTab(status, index) {
      this.activeIndex = index;
      this.status = status;
      isClick = true
      this.onRefresh()
    }
  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/base.less';

/deep/ .van-tab {
  font-size: 0.4rem;
}

.gc-list-project-wrap {
  padding-bottom: 0.3rem;
}

.list-project-menu {
  margin: 0.28rem .28rem 0;
  padding: 0 .48rem;
  background-color: #ffffff;
  box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
  border-radius: 0.27rem;

  .item {
    padding: .5rem 0;
    border-top: 1px solid #ddd;

    &:first-child {
      border-top: none;
    }

    .title {
      font-size: 0.4rem;
      font-weight: 700;
      color: #333333;
      display: flex;
      justify-content: space-between;
      margin-bottom: 0.3rem;

      i {
        flex: 0 0 .48rem;
        margin-left: 0.2rem;
        width: 0.48rem;
        height: 0.48rem;
        background-size: contain;

        &.i0 {
          background-image: url('~@/assets/more.png');
        }

        &.i1 {
          background-image: url('~@/assets/join.png');
        }

        &.i2 {
          background-image: url('~@/assets/more.png');
        }

        &.i3 {
          background-image: url('~@/assets/ing.png');
        }

        &.i4 {
          background-image: url('~@/assets/finished.png');
        }
      }
    }

    .info {
      font-size: 0.3rem;
      color: #888888;

      p {
        margin-top: 0.08rem;
      }

      span {
        font-size: 0.32rem;
        color: #666666;
      }

      b {
        font-weight: normal;

        &.status1 {
          color: #0090ff; //待参与
        }

        &.status2 {
          color: #B71C1C; //待审核
        }

        &.status3 {
          color: #D32F2F; //执行中
        }

        &.status4 {
          color: #9ee355; //已完成
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/project/Review.vue